import script from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=1fb8621b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fb8621b"]])

export default __exports__